<template>
  <div>
    <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
    <div
      class="modal fade"
      id="AddCategoryModal"
      tabindex="-1"
      aria-labelledby="AddNewChannelModalLabel"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AddNewChannelModal_content border-0">
          <div class="modal-header AddNewChannelModal_header">
            <h5 class="modal-title" id="AddNewChannelModalLabel">
              <img
                src="../../assets/images/left.svg"
                class="me-2"
                width="20"
                height="20"
              />
              Add Category
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit="processForm" method="post">
            <!-- error messages for form validation -->
            <p v-if="errors.length">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </ul>
            </p>

            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label"
                      >Category Name</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="c_name"
                      v-model="name"
                      id="c_name"
                    />
                  </div>
                </div>
              </div>
              
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_image" class="form-label"
                      >Thumb Image</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      class="form-control bg-input border-0"
                      type="file"
                      name="c_image"
                      id="c_image"
                      aria-describedby="imageHelp"
                      accept="image/jpeg, image/png"
                      @change="onImageFileChange"
                    />
                    <div id="imageHelp" class="form-text">
                      * Preferred image ratio 1:1 (ex. 512px * 512px Or 1200px *
                      1200px)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-sm"
                data-bs-dismiss="modal"
                @click="processForm"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

export default {
  name: "AddCategoryModal",
  components: { Loading },
  data() {
    return {
      errors: [],
      name: undefined,
      selectedImageFile: undefined,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    onImageFileChange(event) {
      this.selectedImageFile = event.target.files[0];
    },
    processForm() {
      if (this.checkForm()) {
        if (this.selectedImageFile) {
          this.createWithImage();
        } else {
          this.createWithOutImage();
        }
      }
    },
    checkForm(e) {
      if (this.name) {
        return true;
      }
      this.errors = [];
      if (!this.name) {
        this.errors.push("Name required.");
        return false;
      }
      e.preventDefault();
      return false;
    },
    async createWithImage() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("files", this.selectedImageFile);
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.post(
        this.$baseUrl +
          this.$api +
          this.$version1 +
          "/categories/add/with-image",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      this.isLoading = false;
      if (res.status == 200 || res.status == 201) {
        this.$vToastify.success("Category created successfully!.");
        this.$router.go();
      } else {
        this.$vToastify.info(
          "Something went wrong, please refresh and try again."
        );
      }
    },

    async createWithOutImage() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.post(
        this.$baseUrl +
          this.$api +
          this.$version1 +
          "/categories/add/with-out-image",
        {
          name:this.name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      this.isLoading = false;
      if (res.status == 200 || res.status == 201) {
        this.$vToastify.success("Category created successfully!.");
        this.$router.go();
      } else {
        this.$vToastify.info(
          "Something went wrong, please refresh and try again."
        );
      }
    },
  },
};
</script>